var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M20.5 13.5v-4h-2.294a6.929 6.929 0 0 0-.548-1.33l1.62-1.62-2.828-2.828-1.62 1.62a6.929 6.929 0 0 0-1.33-.548V2.5h-4v2.294a6.929 6.929 0 0 0-1.33.548l-1.62-1.62L3.722 6.55l1.62 1.62a6.929 6.929 0 0 0-.548 1.33H2.5v4h2.294c.139.465.32.911.548 1.33l-1.62 1.62 2.828 2.828 1.62-1.62c.419.227.865.41 1.33.548V20.5h4v-2.294a6.929 6.929 0 0 0 1.33-.548l1.62 1.62 2.828-2.828-1.62-1.62c.228-.419.409-.865.548-1.33zm-6-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgSettings as ReactComponent };
export default __webpack_public_path__ + "94df902f88ac399ed7875385351e235b.svg";